import React from 'react';
import Button from 'react-bootstrap/Button';

import Column from './base.jsx';


var columnOptions = {
  id: 'f',
  title: 'Read More Link'
};


var HeaderColumn = function() {
  return <th></th>;
}


class DetailColumn extends React.Component {
  render() {
    return (
      <td className="text-right">
        <Button href={this.props.row.permalink} size="sm">Read&nbsp;more</Button>
      </td>
    );
  }
}


class CallToAction extends Column {
  get id() {
    return columnOptions.id;
  }

  get title() {
    return columnOptions.title;
  }

  get DetailColumn() {
    return DetailColumn;
  }

  get HeaderColumn() {
    return HeaderColumn;
  }
}


export default CallToAction;

